export function useCaptcha (cb: Window["captchaCb"]) {
  if (process.server || !window.smartCaptcha) return

  window.captchaCb = cb
  window.smartCaptcha.reset()
  window.smartCaptcha.execute()
}
